// import React, { useState, useEffect } from 'react';
// import { FiSearch, FiX } from 'react-icons/fi';

// const SearchBar = ({
//     data = [],
//     searchFields = [],
//     onSearchResults,
//     placeholder = "Search...",
//     debounceTime = 300
// }) => {
//     const [searchTerm, setSearchTerm] = useState('');
//     const [isFocused, setIsFocused] = useState(false);

//     // Debounce the search to improve performance
//     useEffect(() => {
//         const timer = setTimeout(() => {
//             if (searchTerm.trim() === '') {
//                 onSearchResults(data);
//                 return;
//             }

//             const results = data.filter(item => {
//                 return searchFields.some(field => {
//                     const fieldValue = item[field]?.toString().toLowerCase() || '';
//                     return fieldValue.includes(searchTerm.toLowerCase());
//                 });
//             });

//             onSearchResults(results);
//         }, debounceTime);

//         return () => clearTimeout(timer);
//     }, [searchTerm, data, searchFields, debounceTime, onSearchResults]);

//     const clearSearch = () => {
//         setSearchTerm('');
//         onSearchResults(data);
//     };

//     return (
//         <div className={`relative flex items-center w-full max-w-md ${isFocused ? 'ring-2 ring-purple-500' : ''} rounded-lg bg-white border border-gray-300 transition-all duration-200`}>
//             <div className="absolute left-3 text-gray-400">
//                 <FiSearch size={18} />
//             </div>
//             <input
//                 type="text"
//                 value={searchTerm}
//                 onChange={(e) => setSearchTerm(e.target.value)}
//                 onFocus={() => setIsFocused(true)}
//                 onBlur={() => setIsFocused(false)}
//                 placeholder={placeholder}
//                 className="w-full py-2 pl-10 pr-8 text-sm text-gray-700 bg-transparent border-none focus:outline-none focus:ring-0"
//             />
//             {searchTerm && (
//                 <button
//                     onClick={clearSearch}
//                     className="absolute right-3 text-gray-400 hover:text-gray-600 transition-colors"
//                     aria-label="Clear search"
//                 >
//                     <FiX size={18} />
//                 </button>
//             )}
//         </div>
//     );
// };

// export default SearchBar;

import React, { useState, useEffect, useRef } from "react";
import { FiSearch, FiX } from "react-icons/fi";

const SearchBar = ({
  data = [],
  searchFields = [],
  onSearchResults,
  onQueryChange,
  placeholder = "Search...",
  debounceTime = 300,
}) => {
  const [searchTerm, setSearchTerm] = useState("");
  const [isFocused, setIsFocused] = useState(false);
  const lastProcessedTerm = useRef("");

  useEffect(() => {
    if (searchTerm === lastProcessedTerm.current && searchTerm !== "") return;

    const timer = setTimeout(() => {
      lastProcessedTerm.current = searchTerm;

      if (onQueryChange) {
        onQueryChange(searchTerm);
        return;
      }

      if (onSearchResults) {
        if (searchTerm.trim() === "") {
          onSearchResults(data);
        } else {
          const results = data.filter((item) => {
            return searchFields.some((field) => {
              const fieldValue = item[field]?.toString().toLowerCase() || "";
              return fieldValue.includes(searchTerm.toLowerCase());
            });
          });
          onSearchResults(results);
        }
      }
    }, debounceTime);

    return () => clearTimeout(timer);
  }, [
    searchTerm,
    data,
    searchFields,
    debounceTime,
    onSearchResults,
    onQueryChange,
  ]);

  const clearSearch = () => {
    setSearchTerm("");
  };

  return (
    <div
      className={`relative flex items-center w-full max-w-md ${isFocused ? "ring-2 ring-purple-500" : ""} rounded-lg bg-white border border-gray-300 transition-all duration-200`}
    >
      <div className="absolute left-3 text-gray-400">
        <FiSearch size={18} />
      </div>
      <input
        type="text"
        value={searchTerm}
        onChange={(e) => setSearchTerm(e.target.value)}
        onFocus={() => setIsFocused(true)}
        onBlur={() => setIsFocused(false)}
        placeholder={placeholder}
        className="w-full py-2 pl-10 pr-8 text-sm text-gray-700 bg-transparent border-none focus:outline-none focus:ring-0"
      />
      {searchTerm && (
        <button
          onClick={clearSearch}
          className="absolute right-3 text-gray-400 hover:text-gray-600"
        >
          <FiX size={18} />
        </button>
      )}
    </div>
  );
};

export default SearchBar;
